export const IDENTITY_DOCUMENT_TYPES = [
  {
    label: "Drivers License",
    value: "Drivers License",
  },
  {
    label: "National Identity Card",
    value: "NIN",
  },
  {
    label: "Voters Card",
    value: "Voters Card",
  },
  // {
  //   label: 'International Passport',
  //   value: 'International Passport',
  // },
];

export const GENDER = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
  { label: "Don't Mind", value: "Don't Mind" },
];

export const RELIGION = [
  {
    label: "Christainity",
    value: "Christainity",
  },
  {
    label: "Muslim",
    value: "Muslim",
  },
];
export const JOB_TYPE = [
  {
    label: "live In",
    value: "Live In",
  },
  {
    label: "live Out",
    value: "live Out",
  },
];
export const EMPLOYMENT_TYPE = [
  {
    label: "Full-Time",
    value: "Full-Time",
  },
  {
    label: "Part-Time",
    value: "Part-Time",
  },
  {
    label: "Contract",
    value: "Contract",
  },
];
export const EDUCATION_LEVEL = [
  { label: "Primary", value: "Primary" },
  { label: "Secondary", value: "Tertiary" },
  { label: "University", value: "University" },
  { label: "Other", value: "Other" },
];
export const AD_POINTS_VALUE = 100;

export const GUARANTORSHIPS = [
  {
    label: "Father",
    value: "Father",
  },
  {
    label: "Mother",
    value: "Mother",
  },
  {
    label: "Brother",
    value: "Brother",
  },
  {
    label: "Sister",
    value: "Sister",
  },
  {
    label: "Uncle",
    value: "Uncle",
  },
  {
    label: "Clergy",
    value: "Clergy",
  },
];
export const myndaType = [
  {
    label: "Live-In",
    value: "Live-In",
  },
  {
    label: "Live-Out",
    value: "Live-Out",
  },
];

export enum MyndaType {
  LeaveIn = "Live-In",
  LeaveOut = "Live-Out",
  daily = "daily",
  weekly = "weekly",
  hourly = "hourly",
}

export const yearsOfExperience = [
  {
    label: "0–1 years",
    value: "0–1 years",
  },
  {
    label: "2–3 years",
    value: "2–3 years",
  },
  {
    label: "4–6 years",
    value: "4–6 years",
  },
  {
    label: "7–10 years",
    value: "7–10 years",
  },
  {
    label: "7–10 years",
    value: "10+ years",
  },
];
